import { BaseService } from './BaseService';

export class LogService extends BaseService {
    constructor() {
        let collectionName = 'log';
        super(collectionName);
    }
}
